export default __webpack_public_path__ + "static/media/Lora-SemiBold.2d21a877.ttf";